module.exports = __webpack_public_path__ + "static/media/Electrificacion motriz resto mineria.f8c46ad9.jpg";